import React from 'react';
import { motion } from 'framer-motion';
import { Zap } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export function Sistema24K() {
  const {
    t
  } = useLanguage();
  return <section id="sistema" className="py-20 bg-brand-darker relative overflow-hidden" data-id="element-383">
      {/* Decorative background */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-full bg-brand-cyan/5 blur-[100px] rounded-full pointer-events-none" data-id="element-384"></div>

      <div className="container mx-auto px-6 max-w-4xl relative z-10" data-id="element-385">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-gradient-to-br from-brand-bg to-brand-darker border border-brand-cyan/30 rounded-3xl p-8 md:p-12 shadow-[0_0_40px_rgba(0,212,255,0.1)]" data-id="element-386">
          <div className="flex flex-col items-center text-center mb-10" data-id="element-387">
            <div className="bg-brand-cyan/20 p-4 rounded-2xl mb-6 inline-block" data-id="element-388">
              <Zap className="w-10 h-10 text-brand-cyan" data-id="element-389" />
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-white to-gray-400" data-id="element-390">
              {t('sistema.title')}
            </h2>
          </div>

          <div className="space-y-8 text-lg md:text-xl text-center text-gray-300" data-id="element-391">
            <p data-id="element-392">{t('sistema.text1')}</p>

            <p data-id="element-393">{t('sistema.text2')}</p>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.3
          }} className="pt-6" data-id="element-394">
              <span className="inline-block bg-brand-cyan/10 border border-brand-cyan/50 text-brand-cyan font-bold text-2xl md:text-3xl px-8 py-4 rounded-xl shadow-[0_0_20px_rgba(0,212,255,0.2)]" data-id="element-395">
                {t('sistema.guarantee')}
              </span>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>;
}